import React, { useEffect, useState } from 'react';
import GConf from '../../AssetsM/generalConf';
import BreadCrumb from '../Assets/breadCrumb';
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Dropdown, Icon, Input } from 'semantic-ui-react';
import FrameForPrint from '../Assets/frameForPrint';
import usePrintFunction from '../Assets/Hooks/printFunction';

function CalendarCommandes() {
    /*#########################[Const]##################################*/
    const [articleEvents , setArticleEvents] = useState([])
    const [jourSelectioner , setJourSelectioner] = useState(new Date().toISOString().split('T')[0])
    const [loading , setLoading] = useState(false)
    const [stateUpdated , setStateUpdated] = useState(false)
    let [camionList, setCamionList] = useState([]);
    let [selectedCam, setSelectedCam] = useState(); 
    /*#########################[UseEffect]##################################*/
    useEffect(() => {
        axios.post(`${GConf.ApiLink}/commande-new/aujourdhui`, {
           tag: GConf.SystemTag,
           date: jourSelectioner,
        })
        .then(function (response) {
            setArticleEvents(response.data)
        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de modifier l'article  </div></>, GConf.TostInternetGonf)   
              setArticleEvents([])
            }
          });
    }, [jourSelectioner,stateUpdated])

    useEffect(() => {
          //camionList
          axios.post(`${GConf.ApiLink}/camions`,{tag:GConf.SystemTag})
          .then(function (response) {
              let ClientLN = []
              response.data.map( (dta) => {ClientLN.push({value : dta.Cam_ID, text : <>{dta.Cam_Name} : {dta.Matricule} - {dta.Chauffeur}</>, key: dta.PK})})
              setCamionList(ClientLN)
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Les camion n'ont pas été chargeé </div></>, GConf.TostInternetGonf)   
            }
          });
    }, [])


    /*#########################[Function]##################################*/
    const SecondPrint  = (frameId) => {usePrintFunction(frameId);} 
    const PrintFunction = (frameId) => {
        if (!selectedCam) {
            alert('selctioner un camion ')
        } else {
             SecondPrint(frameId) 
        }
        
    }

    const RenderToCalendar = (list) =>{
        const groupedData = list.reduce((acc, obj) => {
            const key = obj.Date_Volu;
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
          }, {});
          
          const result = Object.entries(groupedData).map(([key, value]) => {
            return { date: new Date(key).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' ) , title:  value.length  };
          });
          setArticleEvents(result)
          console.log(result)
    }

    const UpdateState = (stateBtn, CID) =>{
         
        axios.post(`${GConf.ApiLink}/commande/controle`, {
            tag: GConf.SystemTag,
            cid: CID,
            state: stateBtn
          })
          .then(function (response) {
                 setStateUpdated(!stateUpdated)
                        
          }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de modifier L'etat du commande  </div></>, GConf.TostInternetGonf)   
              
            }
          });
    }

    const FacturerCommande = (data) =>{
      if (!selectedCam) {
        alert('Selectioner un camion ')
      } else {
        
         setLoading(true)
         
        axios.post(`${GConf.ApiLink}/facture/ajouter`, {
            tag: GConf.SystemTag,
            factD: {client: data.Client, de:'Sidi Bourouis', vers: '', Fournisseurs : selectedCam ,  jour: data.Date_Volu , totale: data.Totale , articles:JSON.parse(data.Articles)},
        })
        .then(function (response) { 
            if(response.status = 200) {
                UpdateState('A', data.C_ID)
                toast.success("Enregistreé !", GConf.TostSuucessGonf)
            }
            else{
                toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                 
            }     
             setLoading(false)      
        }).catch((error) => {
            if(error.request) {
              toast.error(<><div><h5>Probleme de Connextion</h5> Impossible de Facturer la commande  </div></>, GConf.TostInternetGonf)   
            }
          });
         
      }
    }
    
    const CommandeData = (props) => {
            return (
              <div  className='card p-2 mb-2'>
                <div className="row">
                    <div className="col">{props.data.Name}</div>
                    <div className="col">{props.data.Totale}</div>
                    <div className="col">{props.data.State}</div>
                    <div className="col"> <Button disabled={props.data.State != 'W' || loading} className='rounded-pill bg-success text-white' size='mini' onClick={ (e) => FacturerCommande(props.data)}>  Acepteé  <Icon className='ps-2' name='check' /></Button> </div>
                    <div className="col-1"> <Button className='rounded-pill bg-success text-white' size='mini' onClick={ (e) => alert('ok')}>   <Icon   name='print' /></Button> </div>
                     
                </div>
              </div>
            );
      }
          
    return ( <>
        <BreadCrumb links={GConf.BreadCrumb.RequestCalendar} />
        <div className="row">
            <div className="col-12 col-lg-6">
                <h5>Jour Selectioneé   </h5>
                <Input icon='calendar alternate' type='date' size="small" iconPosition='left'   fluid className='mb-1' value={jourSelectioner} onChange={(e) => setJourSelectioner(e.target.value)}/>
              </div>
            <div className="col-12 col-lg-6">
                <h5>Selectionner un Camion    </h5>
                <Dropdown
                      fluid
                      size='large'
                      search
                      selection
                      wrapSelection={false}
                      options={camionList}
                      placeholder='Selectionnez Client'
                      className='mb-1'
                      onChange={(e, { value }) => setSelectedCam(value)}
                      value={selectedCam}
                  />
            </div>
        </div>
        
        <br />
        <div className='row'>
            <div className="col-12 col-lg-9">
              <h5>Les commandes : </h5>
              {articleEvents.map((data, index) => <CommandeData key={index} data={data} /> )}
            </div>
            <div className="col-12 col-lg-3">
                <h5>Contoles : </h5>  
                
                <Button className='rounded bg-success text-white'   onClick={(e) => PrintFunction('commandeGroupList')}> <Icon className='ps-2 mb-2' name='print' /> <br />  
                    <b> Imprimer les commandes A  livreé le :  {new Date(new Date(jourSelectioner).getTime() + 24 * 60 * 60 * 1000).toISOString() .split('T')[0]} </b>
                </Button>
            </div>
        </div> 
        {/* <FullCalendar 
            plugins={[ dayGridPlugin ]}
            initialView="dayGridMonth"
            locale='fr' 
            eventContent={titleFormat}
            events={articleEvents}
            height='510px'
            //allDaySlot= {false}
        /> */}
        <br />
        <br />
        <FrameForPrint frameId='commandeGroupList' src={`/Pr/Camion/commandes/Liste/${selectedCam}/${new Date(new Date(jourSelectioner).getTime() + 24 * 60 * 60 * 1000).toISOString() .split('T')[0]}`} />
    </> );
}

export default CalendarCommandes;